import { useEffect, useRef } from 'react';

export default function useAutoEditNote({
  autoEditNote,
  pageRefs,
  containerRef,
  setHighlightedNoteId,
  setEditingNote,
}) {
  const lastAutoEditNoteId = useRef(null);

  useEffect(() => {
    if (!autoEditNote) {
      lastAutoEditNoteId.current = null;
      return;
    }

    const noteId = autoEditNote.id;
    const noteIdString = noteId ? String(noteId) : '';
    const isTempNote = noteIdString && noteIdString.startsWith('temp-');
    const timestamp = autoEditNote._timestamp || 0;

    if (isTempNote || !noteId) {
      return;
    }

    const noteKey = `${noteId}-${timestamp}`;
    if (lastAutoEditNoteId.current === noteKey) {
      return;
    }

    lastAutoEditNoteId.current = noteKey;

    const navigateOnly = autoEditNote._navigateOnly === true;
    const pageNum = autoEditNote.page_number;

    setTimeout(() => {
      const pageContainer = pageRefs.current[pageNum];

      if (pageContainer && containerRef.current) {
        pageContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

        setHighlightedNoteId(noteId);
        setTimeout(() => {
          setHighlightedNoteId(null);
        }, 2500);
      }
    }, 200);

    if (!navigateOnly) {
      const noteToEdit = {
        ...autoEditNote,
        _autoOpen: true,
      };

      setEditingNote(noteToEdit);
    }
  }, [
    autoEditNote?.id,
    autoEditNote?._timestamp,
    autoEditNote?._autoOpen,
    autoEditNote?._navigateOnly,
    autoEditNote,
    pageRefs,
    containerRef,
    setHighlightedNoteId,
    setEditingNote,
  ]);
}
